import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./index.css";
import { BannerSection } from "./BannerSection";
import { ExploreSection } from "./ExploreSection";
import { WhySection } from "./WhySection";
import { ContactSection } from "./ContactSection";
import { ReviewSection } from "./ReviewSection";
import { HowListenAuraWorks } from "./HowListenAuraWorks";

export const Home = () => {
  const location = useLocation();

  // Smooth-scroll to the hash section when landing on "/" or when hash changes
  useEffect(() => {
    if (location.pathname !== "/") return;

    const id = (location.hash || "#home").slice(1);
    const el = document.getElementById(id);

    if (el) {
      // Small timeout ensures layout is painted before scrolling
      setTimeout(() => {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 0);
    }
  }, [location.pathname, location.hash]);

  return (
    <div className="homeContainer">
      {/* Add IDs + scroll margin so the sticky header doesn't cover the top */}
      <section id="home" className="section-anchor">
        <BannerSection />
      </section>

      <section id="why" className="section-anchor">
        <WhySection />
      </section>

      <section id="how" className="section-anchor">
        <HowListenAuraWorks />
      </section>

      <section id="services" className="section-anchor">
        <ExploreSection />
      </section>

      <section id="testimonials" className="section-anchor">
        <ReviewSection />
      </section>

      <section id="contact" className="section-anchor">
        <ContactSection />
      </section>
    </div>
  );
};
